module.exports = {"title":"Call Van 新的柯打 | GoGoVan 香港","meta":{"keywords":"客貨車,貨van,van仔,貨車,5.5噸貨車,5.5噸,5噸半,尾板車,尾板貨車,街斗,9噸貨車,16噸貨車,密斗車,密斗尾板車,預約貨車,call尾板貨車,尾板貨車租賃,楂5.5噸貨車,貨車尺寸,貨車容量,貨Van容量,貨Van尺寸,貨Van載重,貨van內籠,貨車升降台,貨van高度,貨車高度","description":"新的柯打","og:image":"/img/aboutus-banner.jpg","og:title":"Call Van 新的柯打 | GoGoVan 香港","og:url":"{{SITE_HTTP_URL}}/order","og:description":"新的柯打","og:type":"website","og:site_name":"GoGoVan 香港"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/hk/zh_hk/setting/template_for_angular/locale.json
// module id = 634
// module chunks = 0 1 2 3 4 5